import { FC } from "react";

interface NavPillProps {
    isActive: boolean;
    module: string;
    onNavPillClicked: (module: string) => any;
}

const NavPill: FC<NavPillProps> = ({
    isActive,
    module,
    onNavPillClicked,
}) => {
    return (
        <li className="nav-item" key={module}>
            <div
                className={`nav-link ${isActive ? "active" : ""}`}
                style={{ cursor: "pointer" }}
                onClick={() => onNavPillClicked(module)}
            >
                {module}
            </div>
        </li>
    );
};

export default NavPill;
